import { styled } from "@mui/material";

export const Steps = styled("div")({
  display: "flex",
  flexDirection: "row",
  height: "100%",
  width: "100%",
  minWidth: 0,
  // min-width is needed to deal with unintutive flexbox behavior
  // that prevents the element from shrinking fully
  // when paired with white-space: nowrap within https://codepen.io/aj-foster/pen/emBYPW
});
